import { http } from '@/app/lib/http/client'

export type StoreHomeComponentType = 'HERO' | 'SINGLE_BANNER' | 'BANNER_GRID_3' | 'PRODUCT_CAROUSEL' | 'PROMOTION_SECTION_CARDS' | 'PURCHASE_BENEFITS'

export interface StoreHomeComponent {
  id: number
  component_type: StoreHomeComponentType
  component_id: number
  sort_order: number
  is_active: boolean
}

export const storeDesignService = {
  async getComponents(): Promise<StoreHomeComponent[]> {
    const response = await http.get('/ecommerce/home-components')
    return response.data.data
  },

  async createComponent(data: Omit<StoreHomeComponent, 'id'>): Promise<StoreHomeComponent> {
    const response = await http.post('/ecommerce/home-components', data)
    return response.data.data
  },

  async updateComponent(id: number, data: Partial<Pick<StoreHomeComponent, 'component_id' | 'sort_order' | 'is_active'>>): Promise<StoreHomeComponent> {
    const response = await http.patch(`/ecommerce/home-components/${id}`, data)
    return response.data.data
  },

  async reorderComponents(components: Array<Pick<StoreHomeComponent, 'id' | 'sort_order'>>): Promise<StoreHomeComponent[]> {
    const response = await http.patch('/ecommerce/home-components/reorder', { components })
    return response.data.data
  },

  async deleteComponent(id: number): Promise<void> {
    await http.delete(`/ecommerce/home-components/${id}`)
  },
}
